import { Image } from '@/components/ui/image';
import { logoPlaceholder } from '@/lib/placeholders';

const InfraMaintenanceScreen = () => {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-[#e6e5eb] px-6 text-center">
      <div className="mb-8">
        <Image
          unoptimized
          src={logoPlaceholder}
          alt="Qualidoc"
          width={220}
          height={62}
          className="mx-auto"
        />
      </div>

      <h1 className="text-2xl font-bold text-heading md:text-3xl">
        Voltamos em instantes
      </h1>

      <p className="mt-4 max-w-md text-base text-body md:text-lg">
        Estamos realizando uma manutenção temporária para melhorar sua
        experiência. Por favor, aguarde alguns minutos e tente novamente.
      </p>

      <p className="mt-8 text-sm text-body">
        A página será atualizada automaticamente quando o sistema estiver
        disponível.
      </p>
    </main>
  );
};

export default InfraMaintenanceScreen;
